export enum PromiseStatus {
  FULFILLED = "fulfilled",
  REJECTED = "rejected",
}
